import { Col, Form, Input, message, Modal, Row } from "antd";
import { Rule } from "antd/lib/form";
import { partnerApi } from "api/partner.api";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { ModalStatus } from "types/modal";
import { Partner } from "types/partner";

const rules: Rule[] = [{ required: true }];

export interface PartnerModal {
  handleCreate: () => void;
  handleUpdate: (partner: Partner) => void;
}
interface PartnerModalProps {
  onClose: () => void;
  onSubmitOk: () => void;
  shopId: number;
}

export const PartnerModal = React.forwardRef(
  ({ onClose, onSubmitOk, shopId }: PartnerModalProps, ref) => {
    const [form] = Form.useForm<Partner>();
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [status, setStatus] = useState<ModalStatus>("create");

    useImperativeHandle<any, PartnerModal>(
      ref,
      () => ({
        handleCreate() {
          form.resetFields();
          setVisible(true);
          setStatus("create");
        },
        handleUpdate(partner: Partner) {
          form.setFieldsValue({ ...partner });
          setVisible(true);
          setStatus("update");
        },
      }),
      []
    );

    const createData = async () => {
      const valid = await form.validateFields();
      const data = { partner: form.getFieldsValue(), shopId };

      setLoading(true);
      try {
        const res = await partnerApi.create(data);
        message.success("Create Partner successfully!");
        onClose();
        setVisible(false);
        onSubmitOk();
      } finally {
        setLoading(false);
      }
    };

    const updateData = async () => {
      const valid = await form.validateFields();
      const data = { partner: form.getFieldsValue(true), shopId };
      setLoading(true);
      try {
        const res = await partnerApi.update(data.partner.id || 0, data);
        message.success("Update Partner successfully!");
        onClose();
        setVisible(false);
        onSubmitOk();
      } finally {
        setLoading(false);
      }
    };

    return (
      (<Modal
        onCancel={() => {
          onClose?.();
          setVisible(false);
        }}
        open={visible}
        title={status == "create" ? "Create Partner" : "Update Partner"}
        style={{ top: 20 }}
        width={700}
        confirmLoading={loading}
        onOk={() => {
          status == "create" ? createData() : updateData();
        }}
      >
        <Form layout="vertical" form={form}>
          <Form.Item label="Tên" name="name" rules={rules}>
            <Input placeholder="" />
          </Form.Item>

          <Form.Item shouldUpdate={true}>
            {() => {
              return (
                <Form.Item label="Logo" name="logo">
                  <SingleImageUpload
                    onUploadOk={(path: string) => {
                      console.log("onUploadOk:", path);
                      form.setFieldsValue({
                        logo: path,
                      });
                    }}
                    imageUrl={form.getFieldValue("logo")}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Form>
      </Modal>)
    );
  }
);
